import React from "react";

export default function MissionCard({
  eyebrow = "First Customer Success",
  step = 1,
  total = 5,
  title,
  body,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  onDismiss,
  complete = false,
}) {
  const dots = Array.from({ length: total }, (_, i) => i < step);

  return (
    <div
      style={{
        border: complete
          ? "1px solid rgba(34,197,94,0.55)"
          : "1px solid rgba(245,197,66,0.55)",
        borderRadius: 18,
        padding: 18,
        marginBottom: 18,
        background: complete
          ? "linear-gradient(135deg, rgba(34,197,94,0.16), rgba(16,38,58,0.98))"
          : "linear-gradient(135deg, rgba(245,197,66,0.14), rgba(16,38,58,0.98))",
        boxShadow: "0 14px 32px rgba(0,0,0,0.22)",
        position: "relative",
      }}
    >
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Close mission"
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          width: 32,
          height: 32,
          borderRadius: 999,
          border: "1px solid rgba(255,255,255,0.16)",
          background: "rgba(15,34,53,0.85)",
          color: "#dbeafe",
          cursor: "pointer",
          fontWeight: 900,
        }}
      >
        ×
      </button>

      <div
        style={{
          display: "flex",
          gap: 18,
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          paddingRight: 36,
        }}
      >
        <div style={{ minWidth: 240, flex: "1 1 360px" }}>
          <div style={{ color: "#f5c542", fontSize: 12, fontWeight: 900, letterSpacing: 0.7, textTransform: "uppercase" }}>
            {eyebrow}
          </div>

          <h2 style={{ margin: "8px 0 8px", color: "#ffffff", fontSize: 22 }}>
            {complete ? "🎉 Mission Complete!" : "🎯 " + title}
          </h2>

          <p style={{ margin: 0, color: "#dbeafe", lineHeight: 1.55, maxWidth: 680 }}>
            {body}
          </p>

          <div style={{ display: "flex", gap: 7, marginTop: 14 }}>
            {dots.map((filled, index) => (
              <span
                key={index}
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 999,
                  background: filled ? "#f5c542" : "rgba(255,255,255,0.18)",
                  display: "inline-block",
                }}
              />
            ))}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
            justifyContent: "flex-end",
            flex: "0 1 320px",
          }}
        >
          {secondaryLabel && (
            <button
              type="button"
              onClick={onSecondary}
              style={{
                padding: "11px 14px",
                borderRadius: 12,
                border: "1px solid rgba(255,255,255,0.16)",
                background: "rgba(15,34,53,0.95)",
                color: "#dbeafe",
                fontWeight: 800,
                cursor: "pointer",
                flex: "1 1 140px",
              }}
            >
              {secondaryLabel}
            </button>
          )}

          {primaryLabel && (
            <button
              type="button"
              onClick={onPrimary}
              style={{
                padding: "11px 14px",
                borderRadius: 12,
                border: "none",
                background: "#f5c542",
                color: "#0b1622",
                fontWeight: 900,
                cursor: "pointer",
                flex: "1 1 140px",
              }}
            >
              {primaryLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
